import type { CustomFormField, Customer, CustomerConsent } from '../../types/account';
import type { Offer } from '../../types/checkout';
import type { PaymentDetail, Subscription, Transaction } from '../../types/subscription';

import { createStore } from './utils';

type AccountStore = {
  loading: boolean;
  user: Customer | null;
  cognitoUser: any;
  subscription: Subscription | null;
  allSubscriptions: Subscription[] | null | undefined;
  transactions: Transaction[] | null;
  activePayment: PaymentDetail | null;
  customerConsents: CustomerConsent[] | null;
  publisherConsents: CustomFormField[] | null;
  publisherConsentsLoading: boolean;
  pendingOffer: Offer | null;
  mediaOffer: any | null;
  /** null = not fetched yet after login; true = show My Channel; false = show Create Channel */
  isChannelAvailable: boolean | null;
  /** Handle for My Channel navigation when isChannelAvailable is true */
  myChannelHandle: string | null;
  /** Channel ID for My Channel navigation when isChannelAvailable is true */
  myChannelId: string | null;
  setLoading: (loading: boolean) => void;
  getAccountInfo: () => { customerId: string; customer: Customer; customerConsents: CustomerConsent[] | null };
};

export const useAccountStore = createStore<AccountStore>('AccountStore', (set, get) => ({
  loading: true,
  user: null,
  cognitoUser: {},
  subscription: null,
  allSubscriptions: null,
  transactions: null,
  activePayment: null,
  customerConsents: null,
  publisherConsents: null,
  publisherConsentsLoading: false,
  pendingOffer: null,
  mediaOffer: null,
  isChannelAvailable: null,
  myChannelHandle: null,
  myChannelId: null,
  setLoading: (loading: boolean) => set({ loading }),
  getAccountInfo: () => {
    const user = get().user;
    const customerConsents = get().customerConsents;

    if (!user?.id) { throw new Error('user not logged in'); }

    return { customerId: user?.id, customer: user, customerConsents };
  },
}));
